import React from 'react';

class Impressum extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }

    }

    componentDidMount() {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
    render() {
        return (<>

            <div className="ff-3 mb-5 container">

                <div className="row m-0">
                    <h2 className="col-12 ff-3 text-center mt-5">Impressum</h2>
                </div>
                <div className="row m-0 ">

                    <div className="col-md-6">
                        <p className="text-dark mt-3">Angaben gemäß § 5 TMG:</p>
                        <p className="mt-0">
                            Teigwerk<br />
                            H. Khalil<br />
                            Detmolder Str. 50<br />
                            32545 Bad Oeynhausen
                        </p>

                        <p className="text-dark mt-3">Kontakt</p>
                        <p className="mt-0">
                            Telefon: 05731 98 15 444<br />
                            E-Mail: info@lecker-teigwerk.de
                        </p>

                        {/*   <p className="text-dark mt-3">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</p>
                        <p className="mt-0">
                            Hadi Khalil<br />
                            Teigwerk<br />
                            Detmolder Str. 50<br />
                            32545 Bad Oeynhausen
                        </p> */}

                        <p className="text-dark mt-5">Streitschlichtung</p>
                        <p className="mt-0">
                            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS)
                            bereit: https://ec.europa.eu/consumers/odr.
                            Unsere E-Mail-Adresse finden Sie oben im Impressum.<br />
                            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
                        </p>


                        <p className="text-dark mt-5">Design & Programmierung</p>
                        <p className="mt-0">
                            Arman Khachatryan<br />
                            E-Mail: armanhachatryan04@gmail.com<br />
                            (Trägt keine Verantwortung für den Inhalt)

                        </p>
                    </div>

                    <div className="col-md-6">

                        <p className="text-dark mt-3">Haftung für Inhalte</p>
                        <p className="mt-0">
                            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.<br /><br />
                            Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
                        </p>


                        <p className="text-dark mt-3">Haftung für Links</p>
                        <p className="mt-0">
                            Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.<br /><br />
                            Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                        </p>
                    </div>

                    <div className="col-12">
                        <p className="text-dark mt-3">Urheberrecht</p>
                        <p className="mt-0">
                            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.<br /><br />
                            Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
                        </p>
                    </div>
                    <div className="col-12 text-center">
                        <p>Alle Angaben ohne Gewähr</p>
                    </div>
                </div>


            </div >

        </>);
    }
}

export default Impressum;